// Modules
import React, {useEffect, useState} from 'react';
import { pdfjs, Document, Page } from 'react-pdf';

// Styles
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

// Components
import Header from "./Header";
import Footer from "./Footer";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;


const GrievancePolicyUI = () => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [pdfWidth, setPdfWidth] = useState(800);
    const [pdfHeight, setPdfHeight] = useState(1200);

    useEffect(() => {
        if (process.browser) {
            const width = (window.innerWidth - 50) > 800 ? 800 : (window.innerWidth - 50);
            setPdfWidth(width);
            setPdfHeight(width * 1.5);
        }
    }, [])

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    return (
        <main className="main">
            <Header/>

            <div className='pad--l4 flex--center--center flex__flow--column' style={{maxWidth: 800, marginLeft: 'auto', marginRight: 'auto'}}>
                <h1 className='sectionHeading text__align--center'>Grievance Policy</h1>

                <Document file="/assets/privacy-policy.pdf" options={{
                    cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
                    cMapPacked: true,
                }} onLoadSuccess={onDocumentLoadSuccess} height={1300} width={800}>
                    <Page pageNumber={pageNumber} height={pdfHeight} width={pdfWidth} />
                </Document>

                <div className='width--full display--flex flex__justifyContent--between fontSize--h5'>
                    <span onClick={() => setPageNumber(prevState => prevState-1)} style={pageNumber===1 ? {color: 'rgba(0,0,0,0.5)', pointerEvents: 'none'} : {color: 'rgba(0,0,0,1)', fontFamily: 'met_bold'}}>{'<'} Prev</span>
                    <div className=''>Page {pageNumber} of {numPages}</div>
                    <span onClick={() => setPageNumber(prevState => prevState+1)} style={pageNumber===numPages ? {color: 'rgba(0,0,0,0.5)', pointerEvents: 'none'} : {color: 'rgba(0,0,0,1)', fontFamily: 'met_bold'}}>Next {'>'}</span>
                </div>
            </div>

            <Footer/>
        </main>
    );
};

export default GrievancePolicyUI;
